import React, { useState, useRef, useEffect } from 'react';

import './drop-group.scss';
import useOnClickOutside from 'hooks/useOnClickOutside';
import Svg from 'common/Svg';

export interface StyledSuggestProps {
	className?: string;
	placeholder?: string;
	value: string | null;
	list: any[];
	onChange: (option: any, index: number) => void;
	onChangeText?: (text: string) => void;
	onDropDown: (text: string | null) => void;
	error?: string | null;
	// eslint-disable-next-line no-undef
	renderItem?: (option: any, index: number) => JSX.Element;
}

const StyledSuggest: React.FC<StyledSuggestProps> = ({
	className = '',
	value,
	list,
	placeholder = '',
	onDropDown,
	onChange,
	renderItem,
	error,
	onChangeText,
}) => {
	const popupRef = useRef(null);
	const allRef = useRef(null);
	const [isOpen, setIsOpen] = useState(false);
	const [stateValue, setStateValue] = useState(value);

	useEffect(() => {
		setStateValue(value);
	}, [value]);

	useOnClickOutside(allRef, () => {
		setStateValue(value);
	});

	useOnClickOutside(popupRef, () => {
		setIsOpen(false);
	});

	const handleFocus = () => {
		onDropDown(stateValue);
		setIsOpen(true);
	};

	const handleChangeText = (event: React.ChangeEvent<HTMLInputElement>): void => {
		setStateValue(event.target.value);
		if (onChangeText) {
			onChangeText(event.target.value);
		}
		onDropDown(event.target.value);
		setIsOpen(true);
	};

	const handleChange = (option: any, index: number): void => {
		onChange(option, index);
		setIsOpen(false);
	};

	return (
		<div className={`drop-group ${className}`}>
			<div className={`drop-group__btn ${isOpen ? 'open' : ''}`}>
				<div className="drop-group__item">
					<input
						ref={allRef}
						className={`drop-group__input ${error && 'error'}`}
						placeholder={placeholder}
						value={stateValue || ''}
						onFocus={handleFocus}
						onChange={handleChangeText}
						autoComplete="off"
					/>
					<div className="drop-group__bar">
						<div className="drop-group__icn drop">
							<Svg name="dropdown" />
						</div>
					</div>
				</div>
			</div>
			<div ref={popupRef} className={`drop-group__hide ${isOpen ? 'open' : ''}`}>
				{list.map((option, index) => (
					<div
						className="drop-group__item"
						key={`option_${index}`}
						onClick={() => handleChange(option, index)}
					>
						{renderItem ? renderItem(option, index) : <div className="drop-group__txt">{option}</div>}
					</div>
				))}
			</div>
			{error && <div className="error">{error}</div>}
		</div>
	);
};

export default StyledSuggest;
